module.exports = __webpack_public_path__ + "img/TKM.e8f42000.svg";